import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Timeline {
	constructor() {
		this.$body = $('body');
		this.$header = $('.header');
		this.scrollTop = this.$header.scrollTop;
        //this.timelineFilterGroup = $('.timeline-filter-group');
		this.$timelineFilterBtn = $('.timeline-filter-group .js-timeline-filter button');
		this.$timelineContentRow = $('.timeline-content .row');
		this.$timelineContentBackTimelineTop = $('.timeline-content .back-to-timeline-top');
		this.$timelineFiltersToggleBtn = $('.js-toggle-timeline-filter');
		this.$timelineFilters = $('.timeline-filter-group .js-timeline-filter');
		this.$timelineFilter = $('.js-timeline-filter');
		this.$timelineFilterBtnReset = $('.timeline-filter-group .js-timeline-filter button.reset');
		this.$timelineContentNoInfo = $('.timeline-content .row.no-info');
		this.$timelineContentBackTimelineTopBtn = $('.timeline-content button.back-to-timeline-top-btn');
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        this.$timelineFilterBtn.on('click', e => {
            const target = $(e.currentTarget);
            const buttonGroup = $(e.currentTarget).attr('class');
            const buttonTxt = $(e.currentTarget).text();
            const timelineTop = $(target).parent().closest('.timeline');
            const timelineFilterGroup = $(target).parent().closest('.timeline-filter-group');
            const timelineParent = $(timelineFilterGroup).parent().closest('.timeline');
            $(timelineFilterGroup).find(this.$timelineFilterBtn).removeClass('active').filter(`.${buttonGroup}`)
                .addClass('active');
            $(timelineTop).find(this.$timelineContentRow).addClass('d-none').filter(`.${buttonGroup}`)
                .removeClass('d-none')
                .addClass('show');
            $(timelineFilterGroup).find(this.$timelineFiltersToggleBtn).removeClass('open').text(buttonTxt);
            $(timelineFilterGroup).find(this.$timelineFilter).slideToggle();

            //if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
                $('html, body').animate({ scrollTop: $(timelineTop).offset().top - $('.header').outerHeight() + 1 }, { duration: 1000 });
            //}
        });

        this.$timelineFilterBtnReset.on('click', e => {
            const target = $(e.currentTarget);
            //const buttonGroup = $(e.currentTarget).attr('class');
			const timelineTop = $(target).parent().closest('.timeline');
            $(timelineTop).find(this.$timelineContentRow).removeClass('d-none');
            $(timelineTop).find(this.$timelineContentNoInfo).addClass('d-none');
            $(timelineTop).find(this.$timelineContentBackTimelineTop).addClass('d-none').filter('.reset')
                .removeClass('d-none');
        });

        this.$timelineFiltersToggleBtn.on('click', e => {
			this.toggleTimelineFilters(e);
		});

        this.$timelineContentBackTimelineTopBtn.on('click', e => {
            const target = $(e.currentTarget);
            const timelineTop = $(target).parent().closest('.timeline');
			$('html, body').animate({ scrollTop: $(timelineTop).offset().top - $('.header').outerHeight() + 1 }, { duration: 1000 });
        });

        //window.addEventListener('load', this.urlHashScroll);
        //let urlHash = window.location.href.split('#')[1];
        //window.addEventListener('DOMContentLoaded', function () {
            //if (window.location.hash) {
                //let urlHash = window.location.href.split('#')[1];
                //if (document.getElementById(urlHash)) {
                    //if (window.location.hash) {
                        //if (urlHash.length > 0) {
                            //let anchorHash = `#${urlHash}`;
                            //window.scrollTo(0, 0);
                            //$('html, body').animate({ scrollTop: $(anchorHash).offset().top - $('.header').outerHeight() + 1 }, { duration: 1000 });
                        //}
                    //}
                    //window.scrollTo(0, 0);
                //}
            //}
        //});
    }

	toggleTimelineFilters(e) {
		const target = $(e.currentTarget);
        const timelineTop = $(target).parent().closest('.timeline');
        const timelineFilterGroup = $(target).parent().closest('.timeline-filter-group');
		$(target).toggleClass('open');
		$(timelineFilterGroup).find(this.$timelineFilters).slideToggle();
	}

    //urlHashScroll(e) {
        //if (window.location.hash) {
            //let urlHash = window.location.href.split('#')[1];
            //if (document.getElementById(urlHash)) {
                //if (window.location.hash) {
                    //if (urlHash.length > 0) {
                        //let anchorHash = `#${urlHash}`;
                        //window.scrollTo(0, 0);
                        //$('html, body').animate({ scrollTop: $(anchorHash).offset().top - $('.header').outerHeight() + 1 }, { duration: 1000 });
                    //}
                //}
                //window.scrollTo(0, 0);
            //}
        //}
    //}
}

export default Timeline;